import { render, staticRenderFns } from "./BaseIconRoundButton.vue?vue&type=template&id=0f1773f9&scoped=true&"
import script from "./BaseIconRoundButton.vue?vue&type=script&lang=js&"
export * from "./BaseIconRoundButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseIconRoundButton.vue?vue&type=style&index=0&id=0f1773f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1773f9",
  null
  
)

export default component.exports